import { formatISO, parseISO } from 'date-fns';

/**
 * DateOnlyISOString - full ISO formatted string containing only date from date object in local time zone
 * @example
 * Local time zone: Moscow (+3 hours to UTC)
 * in - '2024-03-28T23:00:00.000Z'
 * out - Thu Mar 28 2024 00:00:00 GMT+0300 (Moscow Standard Time)
 */
export const dateOnlyISOStringToDateObj = (dateISO: string) => {
  return parseISO(dateISO.slice(0, 10));
};

/**
 * DateOnlyISOString - full ISO formatted string containing only date from date object in local time zone
 * @example
 * Local time zone: Moscow (+3 hours to UTC)
 * in - Thu Mar 28 2024 00:00:00 GMT+0300 (Moscow Standard Time)
 * out - '2024-03-28T23:00:00.000Z'
 */
export const dateObjToDateOnlyISOString = (date: Date): string => {
  return formatISO(date, {
    representation: 'date',
  });
};
